import { render } from "./SortTableRegistrationStatusCellComponent.vue?vue&type=template&id=c8ec853e&scoped=true"
import script from "./SortTableRegistrationStatusCellComponent.vue?vue&type=script&lang=js"
export * from "./SortTableRegistrationStatusCellComponent.vue?vue&type=script&lang=js"

import "./SortTableRegistrationStatusCellComponent.vue?vue&type=style&index=0&id=c8ec853e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8ec853e"]])

export default __exports__